import React from "react";
import Flipbook from "../../../flipbook/Flipbook";
import NovelFrame from "../../../flipbook/NovelFrame";
import NovelFinalModal from "../../../utils/modal/NovelFinalModal";

export default function Novel({
  story,
  setStory,
  pageCount,
  showFinalModal,
  setShowFinalModal,
  user_id,
  character_job_id,
  storyPrompt,
  storyId,
  handleChangeBackground,
  setIndex,
}) {
  const [isFlipping, setIsFlipping] = React.useState(false);

  return (
    <NovelFrame
      isFlipping={isFlipping}
      showLogo={false}
      overlays={
        showFinalModal && (
          <NovelFinalModal
            story={story}
            contentList={story}
            onClose={() => {
              setShowFinalModal(false);
            }}
            user_id={user_id}
            character_job_id={character_job_id}
            storyPrompt={storyPrompt}
            storyId={storyId}
          />
        )
      }
    >
      <Flipbook
        story={story}
        setStory={setStory}
        pageCount={pageCount}
        setShowFinalModal={setShowFinalModal}
        setIsFlipping={setIsFlipping}
        handleChangeBackground={handleChangeBackground}
        setIndex={setIndex}
      />
    </NovelFrame>
  );
}
